import React from 'react';
import OAuthButton from './OAuthButton';

const OAuthDemo = () => {
  const handleOAuthClick = (provider) => {
    console.log(`${provider} OAuth clicked`);
    alert(`${provider} OAuth integration would start here`);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-md mx-auto bg-white rounded-2xl shadow-xl p-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-6 text-center">
          OAuth Button Demo
        </h1>
        
        <div className="space-y-4">
          <OAuthButton 
            provider="google"
            onClick={() => handleOAuthClick('Google')}
          />
          
          <OAuthButton 
            provider="facebook"
            onClick={() => handleOAuthClick('Facebook')}
          />
          
          <OAuthButton 
            provider="apple"
            onClick={() => handleOAuthClick('Apple')}
          />
          
          <OAuthButton 
            provider="microsoft"
            onClick={() => handleOAuthClick('Microsoft')}
          />
        </div>

        <div className="mt-8 p-4 bg-gray-100 rounded-lg">
          <h3 className="font-semibold text-gray-800 mb-2">Features:</h3>
          <ul className="text-sm text-gray-600 space-y-1">
            <li>✅ Official brand assets</li>
            <li>✅ Proper hover states</li>
            <li>✅ Consistent sizing</li>
            <li>✅ Fallback SVG assets</li>
            <li>✅ Accessibility compliant</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OAuthDemo;